module.exports = __webpack_public_path__ + "static/media/costcase1.be8b2628.png";